import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { Banner, IconGiftCards16 } from '@stitch-fix/mode-react';
import './styles.module.scss';

/**
 * Side door credit incentives banner used by PDP and Shopping Bag for first time purchases.
 */
const CreditIncentivesBanner = ({
  onShoppingBag,
}: {
  onShoppingBag: boolean;
}) => {
  let ciCookie = Cookies.get('SDCIT1Exp');

  if (!ciCookie) {
    // NOTE: Future date should be 2 days ahead and the eligibility should last until end of day
    const futureDate = new Date().setDate(new Date().getDate() + 2);
    const futureHours = new Date(futureDate).setHours(23, 59, 59, 999);
    const futureISODate = new Date(futureHours).toISOString();

    Cookies.set('SDCIT1Exp', futureISODate);

    ciCookie = futureISODate;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // HACK: This helps when testing so that we don't have a flaky snapshot test that will update each day
  const creditIncentivesDate =
    (window as any).gon.env === 'production'
      ? ciCookie
      : '2018-11-21T05:00:00.007Z';
  /* eslint-enable */

  const formattedDate = () => {
    const parsedDate = new Date(creditIncentivesDate);

    const day = parsedDate.getDate();
    const month = parsedDate.getMonth() + 1;
    const year = parsedDate.getFullYear();
    const yearTwoDigits = `${year}`.slice(2);

    return `${month}/${day}/${yearTwoDigits}`;
  };

  const incentivesNotExpired = () => {
    return new Date(ciCookie).getTime() >= new Date().getTime();
  };

  return ciCookie && incentivesNotExpired() ? (
    <Banner
      data-testid="credit-incentives-banner"
      hAlign={{ sm: 'left', md: 'center' }}
      headline={
        onShoppingBag
          ? `Don't miss out. Your $10 credit expires ${formattedDate()}. We'll apply this credit at checkout.`
          : `Get $10 off your first purchase. Offer expires ${formattedDate()}.`
      }
      icon={<IconGiftCards16 color="white" title="gift card icon" />}
      variant="promo-dark"
    >
      {
        null /* HACK: Done to get around a TS error expecting children as a required prop */
      }
    </Banner>
  ) : null;
};

CreditIncentivesBanner.defaultProps = {
  onShoppingBag: false,
};

CreditIncentivesBanner.propTypes = {
  onShoppingBag: PropTypes.bool,
};

export default CreditIncentivesBanner;
